import React from 'react';
import clsx from 'clsx';
import styles from './UIGameTradeCreatorActionButtons.module.scss';
import { UIGameTradeCreatorActionButtonTradeWithBank } from './UIGameTradeCreatorActionButtonTradeWithBank.tsx';
import { UIGameTradeCreatorActionButtonTradeWithOpponents } from './UIGameTradeCreatorActionButtonTradeWithOpponents.tsx';
import { UIGameActionButtonTrade } from '../../UIGameActionButtonsContainer/UIGameActionButtonTrade/index.ts';
export const UIGameTradeCreatorActionButtons = ({ className, isPortraitLayout = false, tradeCreationDataValidator, getCurrentTradeCreationData })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.tradeCreatorActionsContainer, className, {
            [styles.portraitLayout]: isPortraitLayout
        })
    }, /*#__PURE__*/ React.createElement(UIGameTradeCreatorActionButtonTradeWithBank, {
        hideTooltip: isPortraitLayout,
        tradeCreationDataValidator: tradeCreationDataValidator,
        getCurrentTradeCreationData: getCurrentTradeCreationData
    }), /*#__PURE__*/ React.createElement(UIGameTradeCreatorActionButtonTradeWithOpponents, {
        hideTooltip: isPortraitLayout,
        tradeCreationDataValidator: tradeCreationDataValidator,
        getCurrentTradeCreationData: getCurrentTradeCreationData
    }), isPortraitLayout && /*#__PURE__*/ React.createElement(UIGameActionButtonTrade, {
        className: styles.actionButton
    }));
